import Vue from 'vue';
import { apiPath } from '../constants';

const FeatureFlags = Vue.resource(
  `${apiPath}/feature-flags/`,
  {},
  {
    getConfig: {
      method: 'GET',
    },
  },
  {
    transformToCamelCase: true,
  },
);

export default FeatureFlags;
